import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { toast } from 'react-toastify';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const emailVerified = localStorage.getItem('email_verify');

  // If token is missing or empty
  if (!token) {
    localStorage.clear();
    return <Navigate to="/signin" replace />;
  }
  // If emailVerified is null, undefined, or not 'true'
  if (emailVerified === 'false' ||  emailVerified === false) {
    return (
      <Navigate
        to="/verify-email"
        replace
        state={{
          message: "Please verify your email to continue",
          label: "Verify Email",
        }}
      />
    );
  }

  return children ? children : <Outlet />;
};

export default PrivateRoute;
